import axios from 'axios';
 

export const getBusinessmodel = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}businessmodel`); 
    return response.data;
  } catch (error) {
    console.error('Error fetching menu:', error);
    throw error;
  }
};

